export enum ISortState {
  Inactive = 'inactive',
  Ascending = 'ascending',
  Descending = 'descending'
}
